export class Profile {

	constructor() {
		if (window.location.href.match(/\/ordering\/$/))
			this.replaceBlock = '.ordering-data__kids';
		else
			this.replaceBlock = '.profile-data__wrapper';
	}

	saveBlock(parent, confirmCode = '', sms = 0) {
		let _this = this;
		let form = $(parent);
		let type = form.find('input[type="hidden"][name="block_type"]').val();
		let button = form.find('button[type=submit]');
		button.attr('disabled', true);

		/*if (form.find('input[name=block_type]').val() == 'email' && !confirmed)
		{
			let input = form.find('input[name=str_email]');
			if (input.val() != input.attr('data-original'))
			{
				$(".popup-email").removeClass("active");
				$(".popup-email-edit").addClass("active");

				this.requestConfirm('phone');
				button.attr('disabled', false);
				return;
			}
		}

		if (form.find('input[name=block_type]').val() == 'phone' && !confirmed)
		{
			let input = form.find('input[name=str_phone]');
			if (input.val() != input.attr('data-original'))
			{
				$(".popup-tel").removeClass("active");
				$(".popup-tel-edit").addClass("active");

				this.requestConfirm('email');
				button.attr('disabled', false);
				return;
			}
		}*/

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: form.serialize() + '&action=saveBlock' + (confirmCode ? '&code=' + confirmCode : '') + (sms ? '&type=sms' : ''),
			dataType: "json",
			success: function (res) {
				button.attr('disabled', false);

				if (res['success']) {
					_this.hideMistake(form);
					$(_this.replaceBlock).replaceWith(res['html']);
					_this.applyEvents();
					_this.hidePopup(form.closest('.popup'));
					_this.hidePopup($(".popup-email-change-code"));
					_this.hidePopup($(".popup-tel-change-code"));
				}
				else if (res['need_confirm']) {
					if (sms) {
						_this.startTimer('sms');
					}
					else if (type == 'email') {
						$(".popup-email-change").removeClass("active");
						$(".popup-email-change-code").addClass("active");
						_this.startTimer('flashcall');
					}
					else if (type == 'phone') {
						$(".popup-tel-change").removeClass("active");
						$(".popup-tel-change-code").addClass("active");
						_this.startTimer('email');
					}
					console.log(type);
					_this.origChangeForm = parent;
				}
				else {
					_this.showMistake(form, 'Ошибка: ' + res['error']);

					if (res['activate_link']) {
						$('#auth_block .form__mistakes').append('<p><a href="' + res['activate_link'] + '" target="_blank">Выслать код активации повторно</a></p>');
					}
				}

				if (confirmCode && res['error'] == 'Неверный код подтверждения')
				{
					_this.showMistake('.popup-email-change-code__container:visible form', 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				button.attr('disabled', false);
				_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	startTimer(type) {
		let time;
		console.log('start');
		console.log(type);

		if (type == 'email') {
			parent = '.popup-tel-change-code'
			time = 29;
		}
		else if (type == 'flashcall') {
			parent = '.popup-email-change-code__container--flashcall'
			time = 29;
		}
		else if (type == 'sms') {
			parent = '.popup-email-change-code__container--sms'
			time = 29;
		}

		console.log($(parent + ' .code-form__repeat'));
		console.log($(parent + ' .code-form__repeat-timer'));
		console.log($(parent + ' .code-form__repeat-btn'));

		$(parent + ' .code-form__repeat').fadeIn();
		$(parent + ' .code-form__repeat-caption').show();
		$(parent + ' .code-form__repeat-timer').text('00:' + (time < 10 ? '0' : '') + time);
		let intervalId = setInterval(function () {
			time--;
			$(parent + ' .code-form__repeat-timer').text('00:' + (time < 10 ? '0' : '') + time);
			if (time == 0) {
				clearInterval(intervalId);
				$(parent + ' .code-form__repeat-caption').hide();
				$(parent + ' .code-form__repeat-btn').prop('disabled', false);
			}
		}, 1000);
	}

	goToSms() {
		$('.popup-email-change-code__container--flashcall').removeClass('active');
		$('.popup-email-change-code__container--sms').addClass('active');
	}

	subscribe(parent) {
		let _this = this;
		let form = $(parent);
		form.find('.form__loader').addClass('active');

		$.ajax({
			url: "/ajax.php?mid=28",
			type: 'POST',
			data: form.serialize() + '&action=subscribe',
			dataType: "json",
			success: function (res) {
				form.find('.form__loader').removeClass('active');

				if (res['success']) {
					_this.hideMistake(form);
					$('.form__main').hide();
					$('.form__success').fadeIn();
				}
				else {
					_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				form.find('.form__loader').removeClass('active');
				_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	saveSoc(parent) {
		let _this = this;
		let form = $(parent);
		let button = form.find('button[type=submit]');
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: form.serialize() + '&action=saveSoc',
			dataType: "json",
			success: function (res) {
				button.attr('disabled', false);

				if (res['success']) {
					_this.hideMistake(form);
					$('.profile-data__container').replaceWith(res['html']);
					_this.applyEvents();

					if (res['balls_update']) {
						$('.user-nav .user-balance__value').text(res['balls_update']);
					}

					_this.hidePopup(form.closest('.popup'));
				}
				else {
					_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				button.attr('disabled', false);
				_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	changePwd(parent) {
		let _this = this;
		let form = $(parent);
		let button = form.find('button[type=submit]');
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: form.serialize() + '&action=changePwd',
			dataType: "json",
			success: function (res) {
				button.attr('disabled', false);

				if (res['success']) {
					_this.hideMistake(form)
					_this.hidePopup(form.closest('.popup'));
					/* _this.hideMistake(form)
					$('.form__success').html('Пароль успешно сохранен').addClass('active');
					setTimeout(()=> {
						_this.hidePopup(form.closest('.popup'));
						$('.form__success').html('').removeClass('active');
					}, 2000); */

				}
				else {
					_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				button.attr('disabled', false);
				_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	deleteAccount(parent) {
		let _this = this;
		let button = $(parent);
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: { action: 'deleteAccount' },
			dataType: "json",
			success: function (res) {
				button.attr('disabled', false);

				if (res['success']) {
					$('.profile-data__container').replaceWith(res['html']);
					_this.applyEvents();

					_this.hidePopup(button.closest('.popup'));
				}
				else {
					//_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				button.attr('disabled', false);
				//_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	cancelDeleteAccount(parent) {
		let _this = this;
		let button = $(parent);
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: { action: 'cancelDeleteAccount' },
			dataType: "json",
			success: function (res) {
				button.attr('disabled', false);

				if (res['success']) {
					$('.profile-data__container').replaceWith(res['html']);
					_this.applyEvents();

					_this.hidePopup(button.closest('.popup'));
				}
				else {
					//_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				button.attr('disabled', false);
				//_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	requestConfirm(type) {
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: { action: 'requestConfirm', type: type },
			dataType: "json",
			success: function (res) {
				_this.startTimer(type)
			},
			error: function (res) {

			}
		});
	}

	saveWithConfirm(parent, type) {
		let _this = this;
		let code = $(parent).find('input').val();

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: { action: 'checkConfirmCode', type: type, code: code },
			dataType: "json",
			success: function (res) {
				if (res.success) {
					if (type == 'phone')
						type = 'email';
					else if (type == 'email')
						type = 'tel';

					_this.saveBlock($('.popup-' + type + ' form'), true);
				}
				else {
					_this.showMistake(parent, res.error);
				}
			},
			error: function (res) {

			}
		});
	}

	resendConfirmMail() {
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: { action: 'resendConfirmMail' },
			dataType: "json",
			success: function (res) {
				$("body").addClass("no-scroll");
				$(".popup-confirmation-email").addClass("active");
			},
			error: function (res) {

			}
		});
	}

	loadChild(id) {
		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: { action: 'loadChild', id: id },
			dataType: "json",
			success: function (res) {
				$('.popup-kids-change .popup__main').replaceWith($(res['html']).find('.popup__main'));
				$("body").addClass("no-scroll");
				$(".popup-kids-change").addClass("active");
				var cleaveKids = new Cleave(".popup-kids-change input[name^=dte]", {
					date: true,
					delimiter: '.',
					datePattern: ['d', 'm', 'Y']
				});
				$(".popup-kids-change .popup__btn-close").on("click", function (e) {
					$("body").removeClass("no-scroll");
					$(this).closest(".popup").removeClass("active");
				});
			},
			error: function (res) {

			}
		});
	}

	saveChild(parent) {
		let _this = this;
		let form = $(parent);
		let button = form.find('button[type=submit]');
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: form.serialize() + '&action=saveChild',
			dataType: "json",
			success: function (res) {
				button.attr('disabled', false);

				if (res['success']) {
					_this.hideMistake(form);
					$(_this.replaceBlock).replaceWith(res['html']);
					_this.applyEvents();
					_this.hidePopup(form.closest('.popup'));
				}
				else {
					_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				button.attr('disabled', false);
				_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	removeChild(parent) {
		let _this = this;
		let a = $(parent);

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: { action: 'removeChild', id: a.data('id') },
			dataType: "json",
			success: function (res) {
				if (res['success']) {
					$(_this.replaceBlock).replaceWith(res['html']);
					_this.applyEvents();
					_this.hidePopup(a.closest('.popup'));
					_this.hidePopup($('.popup-kids'));
				}
				else {
					alert('Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	cancelOrder(parent)
	{
		let _this = this;
		let a = $(parent);

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: {action: 'cancelOrder', id: a.data('id')},
			dataType: "json",
			success: function(res){
				if (res['success'])
				{
					location.reload();
				}
				else
				{
					alert('Ошибка: ' + res['error']);
					location.reload();
				}
			},
			error: function(res){
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	showMistake(block, text) {
		$(block).find('.form__mistakes').text(text);
		$(block).find('.form__mistakes').show();
	}

	hideMistake(block) {
		$(block).find('.form__mistakes').text('');
		$(block).find('.form__mistakes').hide();
	}

	hidePopup(popup) {
		$("body").removeClass("no-scroll");
		popup.removeClass("active");
	}

	filter() {
		if ($('.form__check-input').is(':checked')) {
			$('.bills-operations__list li[data-lottery=""]').each(function () {
				$(this).slideUp();
			})
		} else {
			$('.bills-operations__list li[data-lottery=""]').each(function () {
				$(this).slideDown();
			})
		}
	}

	applyEvents() {
		let _this = this;

		$(".profile-data__section-edit--personal").on("click", function () {
			$("body").addClass("no-scroll");
			$(".popup-personal").addClass("active");
		});

		$(".profile-data__section-edit--tel-impossible").on("click", function () {
			$("body").addClass("no-scroll");
			$(".popup-tel-impossible").addClass("active");
		});

		$(".profile-data__section-edit--tel-change").on("click", function () {
			$("body").addClass("no-scroll");
			$(".popup-tel-change").addClass("active");
		});

		$(".profile-data__section-edit--email-new").on("click", function () {
			$("body").addClass("no-scroll");
			$(".popup-email-new").addClass("active");
		});

		$(".profile-data__section-edit--email-change").on("click", function () {
			$("body").addClass("no-scroll");
			$(".popup-email-change").addClass("active");
		});

		$(".data-kids__item-add, .ordering-kids__item-add").on("click", function () {
			$("body").addClass("no-scroll");
			$(".popup-kids-new").addClass("active");
		});

		$(".ordering-kids__item-edit--change").on("click", function () {
			$("body").addClass("no-scroll");
			$(".popup-kids-change").addClass("active");
		});

		$(".profile-data__delete").on("click", function () {
			$("body").addClass("no-scroll");
			$(".popup-delete").addClass("active");
		});

		$('a[href^="#"]').on("click", function () {
			let elementClick = $(this).attr("href").replace(/.*#/, '');
			if (elementClick && $('a[name=' + elementClick + ']').length) {
				let destination = $('a[name=' + elementClick + ']').offset().top - $(window).innerHeight() / 8;
				console.log(destination);
				$('html, body').animate({ scrollTop: destination }, 1100);
			}
		});
	}

}
